import React, { useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import "../../../../assets/css/cms/tools.css";
import { TiDelete } from "react-icons/ti";
import { clearPostResultPageResponse } from "../../../../../store/slices/managePredictorTools";
import { getResultPage, getInputPageDetails, getInputPageFaqContent, getInputPageToolContent } from "../../../../../store/actions/cms/predictorTools";

const ResultPage = ({ values, setFieldValue, errors, touched, handleSubmit, handleBlur, showInfoTip, preventTyping,
  dispatch, productId, handleChangeImage, setSaveNext, postResultPageData, inputDetailData,
  inputDetailError
}) => {
  console.log(",,,step3values", values);
  useEffect(() => {
    // for stepper
    dispatch(getInputPageDetails({ "product_id": productId }))
    dispatch(getResultPage({ "product_id": productId }))
    return (() => {
      dispatch(clearPostResultPageResponse());
      setSaveNext(false)
    })
  }, [])

  // for stepper
  useEffect(() => {
    if (
      inputDetailError ||
      (inputDetailData?.header_section !== undefined &&
        (inputDetailData?.header_section == null || inputDetailData?.header_section == ""))
    ) {
      window.location.href = `/cms/tools/manage-predictor/input-form/${productId ? productId : ""}`;
    }
  }, [inputDetailError, inputDetailData]);


  useEffect((_ => {
    if (productId) {
      dispatch(getResultPage({ "product_id": productId }))
    }
  }), [productId])

  useEffect(() => {
    if (postResultPageData) {
      dispatch(getResultPage({ "product_id": productId }))
    }
  }, [postResultPageData])

  return (
    <form onSubmit={handleSubmit}>
      {/* ******************MANAGE RESULT PAGE BLOCK ************** */}

      <div className={"examfilter  mb-4"}>
        <h5 className="mb-4">
          <strong>Manage Result Page </strong>
        </h5>
        <Row>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label>Result Disclaimer</Form.Label>
              <Form.Control
                as="textarea"
                name="rp_disclaimer"
                className={"input_pd"}
                value={values?.rp_disclaimer}
                onChange={(e) =>
                  setFieldValue("rp_disclaimer", e.target.value)
                }
                onBlur={handleBlur}
                onKeyDown={(e) =>
                  preventTyping(e, "rp_disclaimer")
                }
              />
              {errors.rp_disclaimer && touched.rp_disclaimer && (
                <span className="error">{errors.rp_disclaimer}</span>
              )}
            </Form.Group>
          </Col>
        </Row>
        {/* *****************************MAP COLLEGE PREDICTOR BLOCK********************** */}
        <div className="examfilter mb-4">
          <h5 className="mb-4">
            <strong>Map College Predictor</strong>
          </h5>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>CTA Label
                  {values.enable_cp_pitch_for_rp || (values?.cp_cta_name || values?.cp_destination_url || values?.cp_pitch)
                    ? <sup className="icon_star">*</sup>
                    : ""}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="cp_cta_name"
                  className={"input_pd"}
                  placeholder="Enter CTA Label"
                  value={values?.cp_cta_name}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("cp_cta_name", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "cp_cta_name")
                  }
                />
                {errors.cp_cta_name && touched.cp_cta_name && (
                  <span className="error">{errors.cp_cta_name}</span>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Destination URL{values.enable_cp_pitch_for_rp || (values?.cp_cta_name || values?.cp_destination_url || values?.cp_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  type="text"
                  name="cp_destination_url"
                  className={"input_pd"}
                  placeholder="Enter Destination URL"
                  value={values?.cp_destination_url}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("cp_destination_url", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "cp_destination_url")
                  }
                />
                {errors.cp_destination_url && touched.cp_destination_url && (
                  <span className="error">{errors.cp_destination_url}</span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>College Predictor Pitch{values.enable_cp_pitch_for_rp || (values?.cp_cta_name || values?.cp_destination_url || values?.cp_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  type="text"
                  name="cp_pitch"
                  className={"input_pd"}
                  value={values?.cp_pitch}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("cp_pitch", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "cp_pitch")
                  }
                />
                {errors.cp_pitch && touched.cp_pitch && (
                  <span className="error">{errors.cp_pitch}</span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col className="mb-4">
              <Form.Group className="d-inline-flex">
                <Form.Check
                  id="enable_CP"
                  name="enable_cp_pitch_for_rp"
                  type="checkbox"
                  checked={values?.enable_cp_pitch_for_rp ? true : false}
                  onChange={(e) =>
                    setFieldValue("enable_cp_pitch_for_rp", !values?.enable_cp_pitch_for_rp)
                  }
                  value={values?.enable_cp_pitch_for_rp}
                ></Form.Check>
                <Form.Label htmlFor="enable_CP" className="mx-2">
                  {" "}
                  Enable College Predictor Flow On RP Input
                </Form.Label>
              </Form.Group>
            </Col>
          </Row>
          {values?.enable_cp_pitch_for_rp && <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>
                  College Predictor Pitch For RP Input{values?.enable_cp_pitch_for_rp ? <sup className="icon_star">*</sup> : ""} &nbsp;
                  {showInfoTip("cp_checkbox")}
                </Form.Label>
                <Form.Control
                  name="cp_pitch_for_rp"
                  type="text"
                  className={"input_pd"}
                  value={values?.cp_pitch_for_rp}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("cp_pitch_for_rp", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "cp_pitch_for_rp")
                  }
                />
                {errors.cp_pitch_for_rp && touched.cp_pitch_for_rp && (
                  <span className="error">{errors.cp_pitch_for_rp}</span>
                )}
              </Form.Group>
            </Col>
          </Row>}
        </div>

        {/* *******************PRODUCT INTEGRATION BLOCK************ */}
        <div className="examfilter mb-4">
          <h5 className="mb-4">
            <strong>Product Integration</strong>
          </h5>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Title
                  {(values?.mapped_product_title || values?.mapped_product_cta_label || values?.mapped_product_destination_url || values?.mapped_product_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  type="text"
                  name="mapped_product_title"
                  className={"input_pd"}
                  placeholder="Enter Title"
                  value={values?.mapped_product_title}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("mapped_product_title", value)
                  }
                  }
                  onBlur={handleBlur}

                  onKeyDown={(e) =>
                    preventTyping(e, "mapped_product_title")
                  }
                />
                {errors.mapped_product_title && touched.mapped_product_title && (
                  <span className="error">{errors.mapped_product_title}</span>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>CTA Label
                  {(values?.mapped_product_title || values?.mapped_product_cta_label || values?.mapped_product_destination_url || values?.mapped_product_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  name="mapped_product_cta_label"
                  type="text"
                  className={"input_pd"}
                  placeholder="Enter CTA Label"
                  value={values?.mapped_product_cta_label}
                  onBlur={handleBlur}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("mapped_product_cta_label", value)
                  }
                  }
                  onKeyDown={(e) =>
                    preventTyping(e, "mapped_product_cta_label")
                  }
                />
                {errors.mapped_product_cta_label && touched.mapped_product_cta_label && (
                  <span className="error">{errors.mapped_product_cta_label}</span>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Destination URL
                  {(values?.mapped_product_title || values?.mapped_product_cta_label || values?.mapped_product_destination_url || values?.mapped_product_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  name="mapped_product_destination_url"
                  type="text"
                  className={"input_pd"}
                  placeholder="Enter Destination URL"
                  value={values?.mapped_product_destination_url}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("mapped_product_destination_url", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "mapped_product_destination_url")
                  }
                />
                {errors.mapped_product_destination_url && touched.mapped_product_destination_url && (
                  <span className="error">{errors.mapped_product_destination_url}</span>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Product Pitch
                  {(values?.mapped_product_title || values?.mapped_product_cta_label || values?.mapped_product_destination_url || values?.mapped_product_pitch) ? <sup className="icon_star">*</sup> : ""}</Form.Label>
                <Form.Control
                  type="text"
                  name="mapped_product_pitch"
                  className={"input_pd"}
                  value={values?.mapped_product_pitch}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("mapped_product_pitch", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "mapped_product_pitch")
                  }
                />
                {errors.mapped_product_pitch && touched.mapped_product_pitch && (
                  <span className="error">{errors.mapped_product_pitch}</span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </div>

        {/* *****************************PROMOTIONAL BANNER BLOCK********************************** */}
        <div className="examfilter mb-4">
          <h5 className="mb-4">
            <strong>Promotional Banner</strong>
          </h5>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className="d-block ">
                  Upload GIF/Image Web{" "}
                  {(values?.banner_destination || values?.promotion_banner_web || values?.promotion_banner_wap) ? <sup className="icon_star">*</sup> : ""}
                </Form.Label>
                <input
                  name="promotion_banner_web"
                  type="file"
                  // accept=".svg"
                  accept=".jpg,.png,.gif"
                  className="mb-2"
                  onChange={(e) =>
                    handleChangeImage(e, "promotion_banner_web")
                  }
                />
                {typeof values.promotion_banner_web == "string" && values.promotion_banner_web != "" ?
                  <div className="media_image_container mt-2">
                    <a href={values.promotion_banner_web} target="_blank">
                      {values.promotion_banner_web}
                    </a>
                    <span className={"delete_image_btn mt-1"} onClick={() => {
                      setFieldValue("promotion_banner_web", "")
                    }}>
                      <TiDelete />
                    </span>
                  </div>
                  : ""}
                {errors.promotion_banner_web &&
                  touched.promotion_banner_web && (
                    <div className="error">
                      {errors.promotion_banner_web}
                    </div>
                  )}

              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label className="d-block ">
                  Upload GIF/Image Mob{" "}
                  {(values?.banner_destination || values?.promotion_banner_web || values?.promotion_banner_wap) ? <sup className="icon_star">*</sup> : ""}
                </Form.Label>
                <input
                  name="promotion_banner_wap"
                  type="file"
                  // accept=".svg"
                  accept=".jpg,.png,.gif"
                  className="mb-2"
                  onChange={(e) =>
                    handleChangeImage(e, "promotion_banner_wap")
                  }
                />
                {typeof values.promotion_banner_wap == "string" && values.promotion_banner_wap != "" ?
                  <div className="media_image_container mt-2">
                    <a href={values.promotion_banner_wap} target="_blank">
                      {values.promotion_banner_wap}
                    </a>
                    <span className={"delete_image_btn mt-1"} onClick={() => {
                      setFieldValue("promotion_banner_wap", "")
                    }}>
                      <TiDelete />
                    </span>
                  </div>
                  : ""}
                {errors.promotion_banner_wap &&
                  touched.promotion_banner_wap && (
                    <div className="error">
                      {errors.promotion_banner_wap}
                    </div>
                  )}

              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>Destination URL
                  {(values?.banner_destination || values?.promotion_banner_web || values?.promotion_banner_wap) ? <sup className="icon_star">*</sup> : ""}
                </Form.Label>
                <Form.Control
                  name="banner_destination"
                  type="text"
                  className={"input_pd"}
                  placeholder="Enter Destination URL"
                  value={values?.banner_destination}
                  onChange={(e) => {
                    let value = e.target.value;
                    value = value.replace(/^\s+/g, "");
                    setFieldValue("banner_destination", value)
                  }
                  }
                  onBlur={handleBlur}
                  onKeyDown={(e) =>
                    preventTyping(e, "banner_destination")
                  }
                />
                {errors.banner_destination && touched.banner_destination && (
                  <span className="error">{errors.banner_destination}</span>
                )}
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
      {/* ****************SAVE AND CANCEL BUTTONS***************** */}
      <div className={"my-5 d-flex justify-content-start"}>
        <button className={"btnInfo"} type="submit"
        >
          Save
        </button>

      </div>
    </form>
  )
}

export default ResultPage